<script>
    import NotificationModal from "../../../Components/Common/NotificationModal.svelte";
    import {
        getAmountInCurrency,
        goToURL,
    } from "../../../Utils/utilFunctions.svelte";

    export let row = {},
        col = {};

    let isShowMoreEncountersModalOpen = false;

    $: encounters = row.encounters?.length ? [...row.encounters] : [];

    const redirectToEncounter = (id) => {
        goToURL(`/PatientEncounter/view/${id}`);
    };

    const openMoreEncountersModal = () =>
        (isShowMoreEncountersModalOpen = true);

    const closeMoreEncountersModal = () =>
        (isShowMoreEncountersModalOpen = false);
</script>

{#if !encounters.length}
    <p>-</p>
{:else}
    <div
        class="cursor-pointer hover:underline"
        on:click|preventDefault={() =>
            redirectToEncounter(encounters[0].patientEncounterId)}
    >
        {encounters[0].patientEncounterId}, Provider: {encounters[0]
            .providerNumer}, Amount: {getAmountInCurrency(encounters[0].amount)}
    </div>

    {#if encounters.length > 1}
        <p
            class="cursor-pointer underline text-secondary hover:font-bold"
            on:click|preventDefault={openMoreEncountersModal}
        >
            Multiple
        </p>
    {/if}
{/if}

<NotificationModal
    title="All Encounters"
    isModalOpen={isShowMoreEncountersModalOpen}
    closeModal={closeMoreEncountersModal}
    showConfirmBtn={false}
    closeModalFunction={closeMoreEncountersModal}
>
    <div class="flex flex-col gap-y-2 overflow-y-auto max-h-[600px]">
        {#each encounters as encounter}
            <p
                class="cursor-pointer hover:underline"
                on:click|preventDefault={() =>
                    redirectToEncounter(encounter.patientEncounterId)}
            >
                {encounter.patientEncounterId}, Provider: {encounter.providerNumer},
                Amount: {getAmountInCurrency(encounter.amount)}
            </p>
        {/each}
    </div>
</NotificationModal>
